import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { BillingUiModule } from '@vendasta/billing-ui';
import { GalaxyAvatarModule } from '@vendasta/galaxy/avatar';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { GalaxyFrequencyModule } from '@vendasta/galaxy/frequency';
import { GalaxyInputModule } from '@vendasta/galaxy/input';
import { GalaxyTableModule } from '@vendasta/galaxy/table';
import { GalaxyFrequencyToRevenuePeriodPipe } from '../../billing-term-dialog/sales-to-galaxy-frequency.pipe';
import { PackageContentsPopoverModule } from '../package-contents-popover/package-contents-popover.module';
import { ItemPricingTableBaseComponent } from './item-pricing-table-base.component';
import { ItemCommonModule } from '../item-common.module';
import { MatCard, MatCardContent } from '@angular/material/card';

export const ITEM_PRICING_TABLE_DECLARATIONS = [ItemPricingTableBaseComponent];

const MAT_IMPORTS = [CommonModule, MatButtonModule, MatDialogModule, MatIconModule, MatMenuModule, MatTableModule];

const GALAXY_IMPORTS = [
  GalaxyAvatarModule,
  GalaxyFormFieldModule,
  GalaxyFrequencyModule,
  GalaxyInputModule,
  GalaxyTableModule,
  GalaxyFrequencyToRevenuePeriodPipe,
];

export const ITEM_PRICING_TABLE_IMPORTS = [
  ...MAT_IMPORTS,
  ...GALAXY_IMPORTS,
  ItemCommonModule,
  BillingUiModule,
  PackageContentsPopoverModule,
];

@NgModule({
  exports: [ItemPricingTableBaseComponent],
  declarations: ITEM_PRICING_TABLE_DECLARATIONS,
  imports: [ITEM_PRICING_TABLE_IMPORTS, MatCard, MatCardContent],
})
export class ItemPricingTableBaseModule {}
